import React from "react";
import "./Footer.css";
import { FaLinkedinIn, FaFacebookF, FaInstagram, FaEnvelope } from "react-icons/fa";
import Logo from "../../Gallery/VBS_logo_hd.png";
 import { useNavigate } from "react-router-dom";

const Footer = () => {
  // const navigate = useNavigate();
  // const goTo = (path) => {
  //   navigate(path);
  //   window.scrollTo(0, 0);
  // };
  const navigate = useNavigate();

  return (


    <footer className="footer_main">

      <div className="footer_top_wrapper">

        {/* BRAND + ADDRESS */}
        <div className="footer_brand_block">

          <div className="logo_container">
            <img src={Logo} alt="VB SHAH INC" className="brand_logo" />
            <h2 className="brand_name">VB SHAH <span>INC</span></h2>
          </div>

          <p className="brand_tagline">
            Engineering Spares Exports and Industrial Manufacturing Solutions
          </p>

          {/* SOCIAL */}
          <div className="social_cluster">
            <button onClick={() => window.open("https://linkedin.com", "_blank")}><FaLinkedinIn /></button>
            <button onClick={() => window.open("https://facebook.com", "_blank")}><FaFacebookF /></button>
            <button onClick={() => window.open("https://instagram.com", "_blank")}><FaInstagram /></button>
            <button onClick={() => (window.location.href = "mailto:sales.vbshah@gmail.com")}><FaEnvelope /></button>
          </div>

          {/* ADDRESS */}
{/* ADDRESS */}
<div className="footer_contact_info">

  <p>
    <strong>Address:</strong><br />
    E1 – 3rd Floor, Nikumbh Complex,<br />
    Opp. Tomato Restaurant, Behind Raindrops,<br />
    Off C G Road, Ahmedabad – 380006
  </p>

  {/* CLICKABLE PHONE */}
  <p>
    <strong>Office:</strong>
    <a className="footer_phone" href="tel:+917948449933">
      7948449933
    </a>
  </p>

  {/* CLICKABLE EMAIL */}
  <p>
    <strong>Email:</strong>
    <a className="footer_email" href="mailto:sales@vbshah.com">
      sales@vbshah.com
    </a>
  </p>

  <p><strong>GST No:</strong> 24AACHS6562H1Z1</p>
</div>

        </div>

        {/* COLUMN 1 - Materials */}
        <div className="footer_nav_group">
          <h3>Materials</h3>
          <nav>
            <button onClick={() => navigate('/Sspartone')}>SS316L Parts</button>
            <button onClick={()=> navigate("/VC")}>Rubber</button>
            <button onClick={()=> navigate("/Msone")}>Maraging Steel</button>
            <button onClick={()=> navigate("/AdditiveManufacturing")}>Resins</button>
            <button onClick={()=> navigate("/AdditiveManufacturing")}>Nylon</button>
            <button onClick={()=> navigate("/AdditiveManufacturing")}>Polycarbonate</button>
            <button onClick={()=> navigate("/AdditiveManufacturing")}>Polypropylene</button>
            <button onClick={()=> navigate("/CNC")}>ABS</button>
            <button onClick={()=> navigate("/")}>Other...</button>

          </nav>
        </div>

        {/* COLUMN 2 - Design & Software */}
        <div className="footer_nav_group">
          <h3>Design & Software</h3>
          <nav>
            <button onClick={()=> navigate("/Metal3D")}>Metal 3D Printing</button>
            <button onClick={()=> navigate("/CADModelling")}>CAD Modelling</button>
            <button onClick={()=> navigate("/Machine")}>Machining</button>
            <button onClick={()=> navigate("/VC")}>Vacuum Casting</button>
            <button onClick={()=> navigate("/IM")} >Injection Molding</button>
            <button onClick={()=> navigate("/AdditiveManufacturing")} >3D Plastic Printing</button> 
          </nav>
        </div>

        {/* COLUMN 3 - Treatment & Engineering */}
        <div className="footer_nav_group">
          <h3>Treatment & Engineering</h3>
          <nav>
            <button onClick={()=> navigate("/AdditiveManufacturing")}>Additive Manufacturing</button>
                  <button onClick={()=> navigate("/CNC")}>CNC Machining</button>
                  <button onClick={()=> navigate("/VacumF")}>Vacuum Formed Enclosures</button>
                  <button onClick={()=> navigate("/PT")}> Packaging Trays </button>
                   <button onClick={()=> navigate("/MM")} >Mold Manufacturing</button>
                  <button onClick={()=> navigate("/RE")}>Reverse Engineering</button>
          </nav>
        </div>
      </div>

      {/* BOTTOM BAR */}
      <div className="footer_legal_bar">
        <div className="legal_container">
          <p>© {new Date().getFullYear()} VB SHAH INC. All rights reserved.</p>
          <div className="legal_links">
            <button>Terms of Service</button>
            <button>Privacy Policy</button>
          </div>
        </div>
      </div>

    </footer>
  );
};

export default Footer;